import { atom, useAtom } from "jotai";
import dataService from "../../helpers/dataService";
import { useEffect } from "react";

const productTypesAtom = atom([]);

const useProductTypes = (fetchOnLoad) => {
  const [productTypes, setProductTypes] = useAtom(productTypesAtom);

  useEffect(() => {
    if (fetchOnLoad && productTypes.length === 0) onGetProductTypes();
  }, []);

  const onGetProductTypes = () => {
    dataService.get(`constants/types-contrat`, (data) => {
      setProductTypes((data || []).map(({ id, nom }) => ({ id, name: nom })));
    });
  };

  return {
    productTypes,
    onGetProductTypes,
  };
};

export default useProductTypes;
